import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MyAccountAction from '../actions/MyAccountAction';
import Login from '../../components/Login/Login';

const mapStateToProps = state => ({
  resetPasswordSuccess: state.myAccount.resetPasswordSuccess
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    submitLogin: MyAccountAction.submitLogin
  }, dispatch);

const LoginContainer = connect(mapStateToProps, mapDispatchToProps)(Login);

export default LoginContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/LoginContainer.js
 **/